import React from 'react';

export const thumbnailContainerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginRight: '16px',
};

export const thumbnailStyle = (
  index: number,
  maxThumbnailDisplay: number
): React.CSSProperties => ({
  width: '40px',
  height: '40px',
  marginLeft: index === 0 ? '0' : '-10px',
  position: 'relative' as const,
  zIndex: Math.max(maxThumbnailDisplay, index) - index,
});

export const imageContainerStyle: React.CSSProperties = {
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  border: '2px solid white',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
